var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "appeal",
      style: _vm.currentIndex != 0 && !_vm.$isFlag ? "background:#fff" : ""
    },
    [
      _c("header-item", {
        attrs: {
          "title-array": _vm.titleArray,
          "is-show": true,
          "title-mb": _vm.titleArray[0],
          "type-next": "click"
        },
        on: { navBarClick: _vm.navBarClick }
      }),
      _c(
        "div",
        { staticClass: "lt-freeze-form" },
        [
          _c(
            "van-form",
            { staticClass: "appealInfo" },
            [
              _c("van-field", {
                attrs: {
                  label: "绑定手机号：",
                  required: "",
                  rules: _vm.rules.mobileRules,
                  placeholder: "请输入账号绑定手机号"
                },
                model: {
                  value: _vm.unfreezeParams.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.unfreezeParams, "phone", $$v)
                  },
                  expression: "unfreezeParams.phone"
                }
              }),
              _c("van-field", {
                staticStyle: { "border-radius": "0 0 16px 16px" },
                attrs: {
                  label: "短信验证码：",
                  maxlength: "6",
                  required: "",
                  rules: _vm.rules.codeRules
                },
                scopedSlots: _vm._u([
                  {
                    key: "button",
                    fn: function() {
                      return [
                        !_vm.showTime
                          ? _c(
                              "p",
                              {
                                staticStyle: {
                                  color: "#616edf",
                                  cursor: "pointer"
                                },
                                on: { click: _vm.getCode }
                              },
                              [_vm._v(_vm._s(_vm.timeMsg))]
                            )
                          : _c(
                              "p",
                              {
                                staticStyle: {
                                  color: "#878787",
                                  cursor: "pointer"
                                }
                              },
                              [_vm._v(_vm._s(_vm.codeTime) + " S")]
                            )
                      ]
                    },
                    proxy: true
                  }
                ]),
                model: {
                  value: _vm.unfreezeParams.phoneCode,
                  callback: function($$v) {
                    _vm.$set(_vm.unfreezeParams, "phoneCode", $$v)
                  },
                  expression: "unfreezeParams.phoneCode"
                }
              }),
              _c("p", { staticClass: "reg_p" }, [
                _vm._v("*如果一分钟内没有收到验证码请重新获取")
              ]),
              _c(
                "div",
                { staticClass: "bottom" },
                [
                  _c(
                    "van-button",
                    {
                      staticClass: "formClass_btn",
                      attrs: {
                        round: "",
                        block: "",
                        type: "info",
                        color: "#616edf"
                      },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("申请解冻结")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._m(0)
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lt-freeze-description" }, [
      _c("h4", [_vm._v("查询说明：")]),
      _c("p", [
        _vm._v(
          "1、本页面功能仅限官方iOS、官方安卓、官方鸿蒙区组，渠道区组暂不支持查询"
        )
      ]),
      _c("p", [
        _vm._v("2、本页面只能申请解冻保护性冻结账号解除，无法解除违规封停")
      ]),
      _c("p", [
        _vm._v(
          "3、解除保护性冻结前必须要账号申诉通过后，重置并绑定手机号码方可申请解冻，申诉失败或未审核前无法申请解冻，"
        ),
        _c("a", { attrs: { href: "https://lt0.site/ezD4O0" } }, [
          _vm._v("点击这里")
        ]),
        _vm._v("账号申诉")
      ]),
      _c("p", [
        _vm._v("4、若是申诉通过已重置手机号码还未绑定手机，账号完善信息："),
        _c(
          "a",
          {
            attrs: {
              href:
                "https://id.leiting.com/accountCenter/accountList/bindPhoneNum"
            }
          },
          [_vm._v("点击这里")]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }